<template>
  <div v-if="showForm" class="flex justify-center items-center">
    <div
      class="bg-white w-[300px] border border-black flex flex-col gap-4 py-4 px-6 rounded-xl justify-center items-center"
    >
      <div class="text-center font-semibold">
        Оцените, пожалуйста, нашу работу, где 5 звёзд максимальная оценка
      </div>
      <div class="flex flex-row gap-2">
        <Icon
          v-for="index in 5"
          :key="index"
          name="solar:star-bold"
          @mouseover="hoveredStar = index"
          @mouseleave="hoveredStar = 0"
          :class="[
            'text-2xl cursor-pointer border border-black',
            hoveredStar >= index ? 'text-yellow-400' : 'text-sky-100',
            'hover:text-yellow-400',
          ]"
          @click="$emit('rate', index, ticketId)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps<{
    tickets: any;
    ticketId: undefined | number | null;
  }>();

  const hoveredStar = ref(0);

  const showForm = computed(() => {
    if (!props.ticketId) return null;
    const ticket = props.tickets.data?.find((tic: any) => tic.id === props.ticketId);
    return ticket && ticket.status === "CLOSE" && (!ticket.rating || ticket.rating === null)
      ? true
      : false;
  });
</script>

<style></style>
